import { render, staticRenderFns } from "./ProductSelectMobile.vue?vue&type=template&id=588d7be6&scoped=true"
import script from "./ProductSelectMobile.vue?vue&type=script&lang=js"
export * from "./ProductSelectMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectMobile.vue?vue&type=style&index=0&id=588d7be6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d7be6",
  null
  
)

export default component.exports